type Skill = {
  skillId: string;
  skillName: string;
};

export const scoreSkill = (skill: Skill, search: string) => {
  const skillNameToCompare = skill.skillName.toLowerCase();
  const searchToCompare = search.toLowerCase();
  const searchTokens = searchToCompare.split(' ');
  const skillNameTokens = skillNameToCompare.split(' ');
  if (skillNameToCompare === searchToCompare) {
    return 99999;
  } else {
    let score = 0;
    searchTokens.forEach((searchToken) => {
      skillNameTokens.forEach((skillNameToken) => {
        if (skillNameToken === searchToken) {
          score += 100;
        } else if (skillNameToken.startsWith(searchToken)) {
          score += 10;
        } else if (skillNameToken.includes(searchToken)) {
          score += 1;
        }
      });
    });
    return score;
  }
};
